import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, UnorderedListOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const AvaliacoesSetores = () => {
  const { id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [avaliacao, setAvaliacao] = useState({});

  useEffect(() => {
    if (id_avaliacao) {
      carregarAvaliacao(id_avaliacao);
      listarSetores(id_avaliacao);
    }
  }, [id_avaliacao]);

  // CARREGAR AVALIAÇÃO
  const carregarAvaliacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setAvaliacao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(`/avaliacoes/gestao`);
    }
    setLoading(false);
  };

  // LISTAR
  const listarSetores = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_setores/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      navigate(`/avaliacoes/gestao`);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarSetores = async (setores_selected, setores, id) => {
    if (avaliacao?.status_formulario === 1) return false;
    setLoading(true);

    let array_setores = [];
    setores?.map((e) => {
      array_setores.push(e.key);
    });

    const dados_envio = {
      id_cad_avaliacoes: id,
      id_setores: array_setores,
      id_setores_checked: setores_selected,
    };

    const api = await http("post", `v1/avaliacoes_setores/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_setores.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...setores_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Setor <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "setor",
      sorter: (a, b) => a.setor?.localeCompare(b.setor),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.setor?.toLowerCase().includes(pesquisar.toLowerCase()));
    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });

        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarSetores(array, dadosFilter, id_avaliacao);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarSetores(status ? [data.key] : [], [{ key: data.key }], id_avaliacao);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
        <div className="content-item">
          <HeaderPage title="Avaliações" onClickBack={() => navigate(`/avaliacoes/gestao`)} />
          <HeaderTitle
            title="Avaliações Setores"
            subtitle={
              <Text italic>
                <UnorderedListOutlined /> {avaliacao?.descricao ?? ""}
              </Text>
            }
            icon={<CheckCircleOutlined />}
            loading={loading}
          />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <Space direction="vertical">
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Select
                  defaultValue={0}
                  value={marcado}
                  style={{ width: 180, maxWidth: "100%" }}
                  onChange={(e) => setMarcado(e)}
                  options={optionsFiltro}
                />
              </Space>
            </Space>

            <Divider />

            <Table
              loading={loading}
              scroll={{ x: 700 }}
              columns={columns}
              rowSelection={rowSelection}
              dataSource={dadosFilter}
              size="small"
            />
          </Card>
        </div>
      </Col>
    </Row>
  );
};
